import React from 'react';
import { ApplicationEntryEnhancer } from '../../../entrypoint';
import { useDashboardApi, useFeatureApi, useWorkspaceFeatureApi } from '../../../app';

export function createFeaturePluginsStrategy(): ApplicationEntryEnhancer {
    return (create) => (config) => {
        return create({
            ...config,
            route: {
                ...config.route,
                createDashboardRoute(routeConfig) {
                    const Component = config.route.createDashboardRoute(routeConfig);
                    return () => {
                            const dashboardApi = useDashboardApi();
                            const api = useWorkspaceFeatureApi();
                            const featureset = api.getFeatureset();
                            const dash = dashboardApi.getDashboard();
                            const isAllowed = React.useMemo(() => (
                                 featureset.plugin?.enabled && (
                                    featureset.plugin?.config?.include?.includes(dash.pluginId) ||
                                    (!featureset.plugin?.config?.exclude?.includes(dash.pluginId))
                                )
                            ), [featureset.plugin]);
                            React.useEffect(() => {
                                if(featureset.plugin) {
                                    if(!isAllowed) {
                                        api.restrict(featureset.plugin);
                                    }
                                }
                            }, [isAllowed]);
                            return isAllowed ? <Component />: <></>;
                        }
                    }
                }
        });
    };
}
